module.exports = __webpack_public_path__ + "img/web_TOP.8adfce04.png";